import React from 'react';

import { alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import { useRefreshDomainNameVerificationApprovalMutation } from '@dashboard/generated/wp/administrator';
import { Button } from '@mui/material';

type Props = {
  id: string;
};
export default function RefreshVerificationButton({ id }: Props) {
  const [executeMutation, { loading }] = useRefreshDomainNameVerificationApprovalMutation();

  const onClick = async () => {
    const confirmed = window.confirm('Are you sure you want to restart the verification?');
    if (!confirmed) return;

    await executeMutation({ variables: { id } });
    alertSuccess('Verification restarted');
  };

  return (
    <Button variant="outlined" disabled={loading} type="button" onClick={onClick}>
      Refresh verification
    </Button>
  );
}
